import Component from './PhotoGallery';
export default Component;
